
const digest = '52e5226cd451d79fcc775dfb16dc0aa80b751851ac2632f682e945d8eb3ed395';
const classes = {"input":"_input_1sg89_1"};
const css = `._input_1sg89_1 {
  cursor: pointer;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  